export default "__VITE_ASSET__e2Gex6Gv__"